if (!customElements.get('product-form')) {
  class ProductForm extends DbtfyDiscountCode {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.variantIdInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton.querySelector('span');

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      let product_form = this.closest('product-info');

      if (!product_form) {
        product_form = this.closest('product-form');
      }
      if (!product_form) {
        product_form = document.querySelector('product-info');
      }

      const customizableOptions = product_form?.querySelectorAll('.regikit-customizable-product__input.required');

      let validateForm = true;
      let scrolled = false;
      if (product_form?.querySelectorAll('[data-form-validator]').length) {
        product_form.querySelectorAll('[data-form-validator]').forEach((el) => {
          if (typeof el.validate === 'function') {
            ({ validateForm, scrolled } = el.validate(validateForm, scrolled));
          }
        });
      }

      if (!validateForm) {
        return;
      }

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (evt.submitter.id.endsWith('sticky-add-to-cart') && customizableOptions) {
        customizableOptions.forEach((option) => {
          formData.append(option.getAttribute('name'), option.value);
        });
      }

      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id),
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      let freeProduct = false;
      let hasMultipleItems = false;
      let productVariantID = formData.get('id');

      let discountCode = false;

      if (
        product_form?.querySelectorAll('[data-form-data]').length &&
        !evt.submitter.classList.contains('upsell_bundle__submit')
      ) {
        product_form.querySelectorAll('[data-form-data]').forEach((el) => {
          if (typeof el.getFormData === 'function') {
            ({ discountCode, hasMultipleItems } = el.getFormData(evt, formData, hasMultipleItems));
          }
        });
      } else {
        const upsellBundle = product_form?.querySelector('regikit-upsell-bundles');
        if (upsellBundle) {
          discountCode = upsellBundle.dataset.discountName;
        }
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (Regikit.settings.cart_type == 'page') {
            if (Regikit.settings.cart_type_action && Regikit.settings.regikit_upsell_popup == false && !discountCode) {
              window.location = window.routes.cart_url;
            }
          }

          if (discountCode) {
            publish(PUB_SUB_EVENTS.applyDiscount, {
              discountCode: discountCode,
            });
          }

          // const cartIcon = document.querySelector('.header__icon--cart');
          // const image = this.dataset.productVariantMedia;
          // if (cartIcon && this.submitButton && image) {
          //   const flyToCartElement = /** @type {FlyToCart} */ (document.createElement('fly-to-cart'));
          //   flyToCartElement.style.setProperty('background-image', `url(${image})`);
          //   flyToCartElement.source = this.submitButton;
          //   flyToCartElement.destination = cartIcon;
          //   document.body.appendChild(flyToCartElement);
          // }

          let updatedResponse = response;
          if (Array.isArray(response.items) && response.items.length > 0) {
            updatedResponse = response.items[0] ? { ...response.items[0] } : {};
            updatedResponse.sections = response.sections;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: productVariantID,
              cartData: updatedResponse,
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(updatedResponse, Regikit.settings.cart_type_action);
                });
              },
              { once: true },
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(updatedResponse, Regikit.settings.cart_type_action);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    toggleSubmitButton(disable = true, text) {
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    get variantIdInput() {
      return this.form.querySelector('[name=id]') || this.form.querySelector('[name="id[]"]');
    }
  }

  customElements.define('product-form', ProductForm);

  if (!customElements.get('sticky-product-form') && customElements.get('product-form')) {
    class StickyProductForm extends ProductForm {
      constructor() {
        super();
      }
    }
    customElements.define('sticky-product-form', StickyProductForm);
  }
}

if (!customElements.get('fly-to-cart')) {
  class FlyToCart extends HTMLElement {
    /** @type {Element} */
    source;

    /** @type {Element} */
    destination;

    connectedCallback() {
      this.#animate();
    }

    #animate() {
      const rect = this.getBoundingClientRect();
      const sourceRect = this.source.getBoundingClientRect();
      const destinationRect = this.destination.getBoundingClientRect();

      //Define bezier curve points
      // Maybe add half of the size of the flying thingy to the x and y to make it center properly
      const offset = {
        x: rect.width / 2,
        y: rect.height / 2,
      };
      const startPoint = {
        x: sourceRect.left + sourceRect.width / 2 - offset.x,
        y: sourceRect.top + sourceRect.height / 2 - offset.y,
      };

      const endPoint = {
        x: destinationRect.left + destinationRect.width / 2 - offset.x,
        y: destinationRect.top + destinationRect.height / 2 - offset.y,
      };

      //Calculate the control points
      const controlPoint1 = { x: startPoint.x, y: startPoint.y - 200 }; // Go up 200px
      const controlPoint2 = { x: endPoint.x - 300, y: endPoint.y - 100 }; // Go left 300px and up 100px

      //Animation variables
      /** @type {number | null} */
      let startTime = null;
      const duration = 600; // 600ms

      this.style.opacity = '1';

      /**
       * Animates the flying thingy along the bezier curve.
       * @param {number} currentTime - The current time.
       */
      const animate = (currentTime) => {
        if (!startTime) startTime = currentTime;
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // Calculate current position along the bezier curve
        const position = bezierPoint(progress, startPoint, controlPoint1, controlPoint2, endPoint);

        //Update the position of the flying thingy
        this.style.setProperty('--x', `${position.x}px`);
        this.style.setProperty('--y', `${position.y}px`);

        // Scale down as it approaches the cart
        const scale = 1 - progress * 0.5;
        this.style.setProperty('--scale', `${scale}`);

        //Continue the animation if not finished
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          //Fade out the flying thingy
          this.style.opacity = '0';
          //onAnimationEnd(this, () => this.remove());
        }
      };

      // Position the flying thingy back to the start point
      this.style.setProperty('--x', `${startPoint.x}px`);
      this.style.setProperty('--y', `${startPoint.y}px`);

      //Start the animation
      requestAnimationFrame(animate);
    }
  }

  /**
   * Calculates a point on a cubic Bézier curve.
   * @param {number} t - The parameter value (0 <= t <= 1).
   * @param {{x: number, y: number}} p0 - The starting point (x, y).
   * @param {{x: number, y: number}} p1 - The first control point (x, y).
   * @param {{x: number, y: number}} p2 - The second control point (x, y).
   * @param {{x: number, y: number}} p3 - The ending point (x, y).
   * @returns {{x: number, y: number}} The point on the curve.
   */
  function bezierPoint(t, p0, p1, p2, p3) {
    const cX = 3 * (p1.x - p0.x);
    const bX = 3 * (p2.x - p1.x) - cX;
    const aX = p3.x - p0.x - cX - bX;

    const cY = 3 * (p1.y - p0.y);
    const bY = 3 * (p2.y - p1.y) - cY;
    const aY = p3.y - p0.y - cY - bY;

    const x = aX * Math.pow(t, 3) + bX * Math.pow(t, 2) + cX * t + p0.x;
    const y = aY * Math.pow(t, 3) + bY * Math.pow(t, 2) + cY * t + p0.y;

    return { x, y };
  }

  customElements.define('fly-to-cart', FlyToCart);
}